import type { SideOverflowBooleans } from '../types';

export const SVG_NAMESPACE_RESOLVER = 'http://www.w3.org/2000/svg';
export const SVG_NAMESPACE_PREFIX = 'svg:';
export const SHADOW_ROOT_XPATH_SEPARATOR = '/+';
export const TOUR_TOOLTIP_MARGIN = 16;
export const TOUR_TOOLTIP_WIDTH = 250;
export const TOUR_TOOLTIP_HEIGHT = 144;
export const TOUR_APPLY_TO_ALL_HEIGHT = 40;
export const SCROLLBAR_SCROLL_HEIGHT = 50;
export const INITIAL_OVERFLOW_AT_VALUES: SideOverflowBooleans = {
  top: false,
  right: false,
  bottom: false,
  left: false,
};

export const DEFAULT_STEP_CONTENT = 'Add step content here';

export const MAX_Z_INDEX = 2147483647;

export const SCREENSHOT_INNER_CONTAINER_ID =
  'demostack-screenshot-inner-container';
